/**
 * Request Offer Form functionality
 *
 * Handles multi-step form navigation, validation, and submission
 */

;(function ($) {
  'use strict';

  const formSelectors = {
    form: '#request-offer-form',
    steps: '.form-step',
    stepIndicators: '.step-indicator',
    nextButtons: '.next-step',
    prevButtons: '.prev-step',
    submitButton: '.submit-form',
    requiredFields: '[required]'
  };

  /**
   * Initialize the form
   */
  function initForm () {
    const $form = $(formSelectors.form);

    if (!$form.length) {
      return;
    }

    setupEventListeners();
  }

  /**
   * Set up event listeners for the form
   */
  function setupEventListeners () {
    $(formSelectors.nextButtons).off('click').on('click', function () {
      const $currentStep = $(this).closest(formSelectors.steps);
      const currentStepNum = parseInt($currentStep.data('step'));

      if (validateStep($currentStep)) {
        goToStep(currentStepNum + 1);
      }
    });

    $(formSelectors.prevButtons).off('click').on('click', function () {
      const $currentStep = $(this).closest(formSelectors.steps);
      const currentStepNum = parseInt($currentStep.data('step'));
      goToStep(currentStepNum - 1);
    });

    $(formSelectors.submitButton).off('click').on('click', function (e) {
      const $currentStep = $(this).closest(formSelectors.steps);

      if (!validateStep($currentStep)) {
        e.preventDefault();
      }
    });

    $(formSelectors.form).off('submit').on('submit', function (e) {
      e.preventDefault();

      const $currentStep = $(formSelectors.steps + '.active');

      // Validate final step before submission
      if (validateStep($currentStep)) {
        submitForm($(this));
      }
    });

    $(formSelectors.stepIndicators).off('click').on('click', function () {
      const stepNum = parseInt($(this).data('step'));
      const $currentStep = $(formSelectors.steps + '.active');
      const currentStepNum = parseInt($currentStep.data('step'));

      if (stepNum <= currentStepNum) {
        goToStep(stepNum);

        return;
      }

      let previousStepsValid = true;

      $(formSelectors.steps).each(function () {
        if (!previousStepsValid) {
          return;
        }

        const $step = $(this);
        const step = parseInt($step.data('step'));

        if (step > stepNum) {
          return;
        }

        if (!validateStep($step)) {
          previousStepsValid = false;
          goToStep(step);
        }
      });

      if (previousStepsValid) {
        goToStep(stepNum);
      }
    });
  }

  /**
   * Navigate to a specific step
   *
   * @param {number} stepNum - The step number to navigate to
   */
  function goToStep (stepNum) {
    $(formSelectors.steps).removeClass('active').hide();
    $(formSelectors.stepIndicators).removeClass('active complete');

    $(formSelectors.steps + '[data-step="' + stepNum + '"]').addClass('active').show();

    $(formSelectors.stepIndicators).each(function () {
      const currentStep = parseInt($(this).data('step'));

      if (stepNum > currentStep) {
        $(this).addClass('complete');

        $(this).find('.marker .icon').html(DESTI_NATIONS.icons.fullCircleCheckboxSmall);
      } else if (stepNum === currentStep) {
        $(this).addClass('active');

        $(this).find('.marker .icon').html(DESTI_NATIONS.icons.selectedRadioButton);
      } else {
        $(this).find('.marker .icon').html(DESTI_NATIONS.icons.emptyRadioButtonSmall);
      }
    });

    $('html, body').animate({
      scrollTop: $(formSelectors.form).offset().top - 100
    }, 300);
  }

  /**
   * Validate a form step
   *
   * @param {jQuery} $step - The step to validate
   * @returns {boolean} - Whether the step is valid
   */
  function validateStep ($step) {
    let isValid = true;

    // Check all required fields in the current step
    $step.find(formSelectors.requiredFields).each(function () {
      const $field = $(this);

      if ($field.is(':checkbox') && !$field.is(':checked')) {
        isValid = false;
        showError($field, DESTI_NATIONS.i18n.required_field_message);
      } else if (!$field.val()) {
        isValid = false;
        showError($field, DESTI_NATIONS.i18n.required_field_message);
      } else {
        clearError($field);
      }
    });

    return isValid;
  }

  /**
   * Show an error message for a field
   *
   * @param {jQuery} $field - The field with the error
   * @param {string} message - The error message
   */
  function showError ($field, message) {
    // Remove any existing error message
    clearError($field);

    // Add error class to field
    $field.addClass('error');

    // Create and append error message
    const $errorMessage = $('<div class="error-message">' + message + '</div>');

    if ($field.is(':checkbox')) {
      $field.closest('.checkbox-field').append($errorMessage);
    } else {
      $field.after($errorMessage);
    }
  }

  /**
   * Clear error message for a field
   *
   * @param {jQuery} $field - The field to clear error for
   */
  function clearError ($field) {
    $field.removeClass('error');

    if ($field.is(':checkbox')) {
      $field.closest('.checkbox-field').find('.error-message').remove();
    } else {
      $field.next('.error-message').remove();
    }
  }

  /**
   * Submit the form via AJAX
   *
   * @param {jQuery} $form - The form to submit
   */
  function submitForm ($form) {
    const sendingText = DESTI_NATIONS.i18n.sending;
    const successMessage = DESTI_NATIONS.i18n.success_message;
    const errorMessage = DESTI_NATIONS.i18n.error_message;

    // Show loading state
    const $submitButton = $form.find(formSelectors.submitButton);
    const originalButtonText = $submitButton.text();
    $submitButton.prop('disabled', true).text(sendingText);

    // Prepare form data for submission
    const formData = new FormData($form[0]);

    // Add international phone format for intl-tel-input
    // hiddenInput option doesn't work with AJAX submissions, so we manually add it
    const phoneInput = document.querySelector('#phone');

    if (phoneInput && phoneInput.iti) {
      const fullNumber = phoneInput.iti.getNumber();
      const countryData = phoneInput.iti.getSelectedCountryData();

      if (fullNumber) {
        formData.append('full_phone', fullNumber);
      }

      if (countryData && countryData.iso2) {
        formData.append('phone_country', countryData.iso2);
      }
    }

    // Send AJAX request
    $.ajax({
      url: DESTI_NATIONS.ajaxUrl || '/wp-admin/admin-ajax.php',
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      success: function (response) {
        if (response.success) {
          $form.html('<div class="form-success-message">' + (response.data && response.data.message ? response.data.message : successMessage) + '</div>' + (response.data && response.data.tracking ? response.data.tracking : ''));

          $('html, body').animate({
            scrollTop: $form.offset().top - 100
          }, 300);
        } else {
          alert(response.data && response.data.message ? response.data.message : errorMessage);
          $submitButton.prop('disabled', false).text(originalButtonText);
        }
      },
      error: function () {
        alert(errorMessage);
        $submitButton.prop('disabled', false).text(originalButtonText);
      }
    });
  }

  $(document).ready(initForm);

})(jQuery);
